import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'
import {
    TableResponse,
} from 'app/types/request.types'
import {
    PreBooking,
} from 'app/Apps/PreBooking/PreBooking.types'
import requests from 'app/requests/Prebooking.requests'
import {
    PreBookingStatus,
} from 'app/enums/label.enums'

type PrebookingFilters = {
    preBookingStatus?: PreBookingStatus[],
}

export default (filters: PrebookingFilters, enabled: boolean) => {
    return useRequestTable<TableResponse<PreBooking[]>>({
        defaultValue: {
            filter: {
                ...filters,
            },
        },
        params: {},
        config: requests.filterRequest,
        key: RequestKeys.getPreBookings,
        keepPreviousData: true,
        enabled,
    })
}
